import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { FileUploaderComponent } from '../../../../shared/Components/file-uploader/file-uploader.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ComplexAttachementsService } from '../../services/complex-attachements-service';
import { AddComplexAttachementsComponent } from '../add-complex-attachements/add-complex-attachements.component';
import { ComplexAttachementsDetailsComponent } from '../complex-attachements-details/complex-attachements-details.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';
@Component({
  selector: 'get-complex-attachements',
  templateUrl: './get-complex-attachements.component.html',
  styleUrls: ['./get-complex-attachements.component.scss'],
})
export class GetComplexAttachementsComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: ComplexAttachementsService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    public sanitizer: DomSanitizer,
    pagingService: PagingService
  ) {
    super(route, service, pagingService, '', diag);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  intitForm() {
    this.form = this.fb.group({
      nameAR: [''],
    });
  }

  handleSearch() {
    const nameRaw = this.form.value.nameAR;
    const nameTrimmed = nameRaw ? nameRaw.trim() : '';

    if (!nameTrimmed && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاء اختيار العنوان  لاتمام عملية البحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (nameTrimmed) {
      this.form.controls['nameAR'].setValue(nameTrimmed);
      serchTermArr.push(`nameAR:${nameTrimmed}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['nameAR'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  add() {
    this.dialog
      .open(AddComplexAttachementsComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') {
          this.toast.show('تم الاضافة بنجاح', '', { status: 'success', duration: 3000 });
          this.loadEntities();
        }
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(ComplexAttachementsDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = { ...model };
    this.diag
      .open(AddComplexAttachementsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
